<template>
  <ClientOnly>
    <div ref="footer" class="unique-footer">
      <div class="m-auto midfooter">
        <div class="whitecolumns app-max-width">
          <div v-if="!Capacitor.isNativePlatform()" class="whitecolumn space-y-4">
            <div class="flex  items-center gap-2">
              <img src="/img/logo.png" class="rounded h-8" >
              <span class="truncate text-[.7cm] font-black">Learn ATC</span>
            </div>
            <p class="whitespace-normal text-base text-gray-500 font-normal leading-7" v-text="t('footer.provide')"/>
          </div>
          <div v-if="!Capacitor.isNativePlatform()" class="whitecolumn"/>
          <div v-if="!Capacitor.isNativePlatform()" class="whitecolumn">
            <h4 v-text="t('footer.about')"/>
            <ui-link to="/blog" :text="t('footer.links.blog')" />
            <ui-link to="/features" :text="t('footer.links.features')" />
            <ui-link to="/pricing" :text="t('footer.links.pricing')" />
            <ui-link to="/faq" :text="t('footer.links.faq')" />
            <ui-link to="/tos" :text="t('footer.links.tos')" />
          </div>
          <div class="whitecolumn">
            <div class="whitecolumn pb-6">
              <h4 v-text="t('footer.contact')"/>
              <ui-link :href="'mailto:'+appMailOffice" iconleft :text="appMailOffice"/>
              <ui-link href="tel:+4927133885017" text="+49 271 3388 5017" iconleft/>
              <ui-link href="tel:+43723523385" text="+43 7235 233 85" iconleft/>
            </div>
            <div v-if="Capacitor.getPlatform() == 'web'" class="whitecolumn">
              <h4 v-text="t('footer.downloads')"/>
              <ui-link
                href="https://play.google.com/store/apps/details?id=at.blax.learnatc"
                target="_blank"
                iconleft
                class="space-x-2"
                >
                <span v-text="t('footer.androidapp')"/>
                <i class="fab fa-android pl-1 text-green-500"/>
                <i class="fab fa-google-play pl-1 text-blue-500"/>
              </ui-link>
            </div>
            <div v-else>
              <h4  v-text="t('footer.gratitude')"/>
              <p class="text-sm text-gray-500" v-text="t('footer.thankapp', { platform: Capacitor.getPlatform() })"/>
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex align-end">
              <hr class="w-full">
            </div>
          </div>
          <div class="col-span-12 text-sm gap-4">
            <div class="flex flex-col md:flex-row md:items-center justify-between pb-4 w-full text-gray-400 font-semibold">
              <span v-text="t('footer.jointventure')"/>
              <p class="md:m-auto text-center text-sm py-4 flex flex-wrap items-center">
                <span v-text="t('footer.madewith', { heart: '❤️' })" />
                <img
                  :src="imgFlagATDE"
                  class="inline h-5 rounded ml-1"
                  title="Austria & Germany"
                  alt="Austria & Germany" >
              </p>
              <div class="flex flex-wrap flex-col md:flex-row gap-3 md:gap-6">
                <span class="ui-link--blue cursor-pointer" @click="dataShowBugReport = !dataShowBugReport">
                  <span v-text="t('footer.bug')"/>
                  <i class="fas fa-bug pl-2"/>
                </span>
                <ui-link to="/privacy" :text="t('Privacy')"/>
                <ui-link to="/imprint" :text="t('Imprint')"/>
              </div>
            </div>

            <UiModalReportBug v-model="dataShowBugReport"/>
          </div>

          <br class="block md:hidden">
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core';
import imgFlagATDE from '~/assets/img/flag-oe-de.png'

const footer = ref<HTMLElement | null>(null)
const dataShowBugReport = useState<boolean>('modal-bug', () => false)

const { t } = useI18n();

onMounted(() => {
  footer.value?.style.setProperty('bottom', `-${footer.value?.clientHeight}px`)
})
</script>
